import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./UploadProgressOverlay.module.css";

const UploadProgressOverlay = ({ uploadProgress }) => {
  const { t } = useTranslation();

  if (!uploadProgress.isUploading || uploadProgress.total === 0) {
    return null;
  }

  const percentage = Math.round((uploadProgress.uploaded / uploadProgress.total) * 100);

  return (
    <div className={styles.overlay}>
      <div className={styles.overlayInner}>
        <div className={styles.overlayContent}>
          <div className={styles.progressContainer}>
            {/* 제목 */}
            <div className={styles.title}>
              <strong>📤 {t("Uploading images")}...</strong>
            </div>

            {/* 개수 표시 */}
            <div className={styles.count}>
              {uploadProgress.uploaded} / {uploadProgress.total}
            </div>

            {/* 프로그레스바 */}
            <div className={styles.progressBarContainer}>
              <div
                className={styles.progressBar}
                style={{ width: `${percentage}%` }}
              >
                <span className={styles.percentage}>{percentage}%</span>
              </div>
            </div>

            {/* 현재 파일명 */}
            {uploadProgress.currentFile && (
              <div className={styles.currentFile}>
                📁 {t("Current file")}: {uploadProgress.currentFile}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadProgressOverlay;
